import Box, { type BoxProps } from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

interface Props extends BoxProps {
  label: string;
}

/**
 * Small pill-shaped "spinner + label" indicator. Used wherever an async
 * section of the page is mid-flight (map parcels, permits table). Caller
 * controls positioning via `sx` — the pill is `display: inline-flex` by
 * default so it sits inline next to a heading; pass
 * `sx={{ position: 'absolute', top, right }}` to overlay it on a map.
 */
export function LoadingPill({ label, sx, ...rest }: Props) {
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        borderRadius: 999,
        boxShadow: 2,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        px: 1.5,
        py: 0.75,
        ...sx,
      }}
      {...rest}
    >
      <CircularProgress size={16} />
      <Typography variant="caption">{label}</Typography>
    </Box>
  );
}
